// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9u-3";
export var contentContainer = "_9u-0";
export var editorContainer = "_9u-1";
export var quillInputForm = "_9u-2";
export var zoneDivider = "_9u-4";